(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["advent-calendar-intro"] && !Shopify.designMode) return;
  try {
    (() => {
  const boot = () => document.querySelectorAll('[data-advent-config]').forEach(start);
  function start(configNode) {
    if (configNode.dataset.started || window.Shopify?.designMode || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    configNode.dataset.started = 'true';
    let config;
    try { config = JSON.parse(configNode.textContent); } catch { return; }
    if (matchMedia('(max-width: 64rem)').matches && config.tableMobile) config.table = config.tableMobile;
    const target = document.querySelector(config.target);
    if (!config.enabled || !target || !config.table || document.querySelector('.calendar-opening')) return;
    const overlay = document.createElement('div');
    overlay.className = 'calendar-opening';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.dataset.calendar = config.profile;
    overlay.dataset.hinge = config.hinge === 'right' ? 'right' : 'left';
    overlay.innerHTML = '<div class="calendar-backdrop"></div><div class="calendar-camera"><div class="calendar-sheet"><div class="calendar-package-edge"></div><div class="calendar-board calendar-print"></div><div class="aperture-rim"></div><div class="aperture-shadow"></div><div class="calendar-hinge"><div class="calendar-flap"><div class="flap-front paper-face"><div class="flap-print calendar-print"></div><div class="paper-light paper-light-front"></div><div class="perforation"></div></div><div class="flap-back paper-face"><span class="paper-fold"></span><div class="paper-light paper-light-back"></div></div><div class="paper-edge"></div></div></div></div></div>';
    const part = name => overlay.querySelector('.' + name);
    const animations = [];
    let closed = false;
    let resizeObserver;
    let startupDeadline;
    const previous = { overflow: document.body.style.overflow, padding: document.body.style.paddingRight };
    const focused = document.activeElement;
    const inert = Array.from(document.body.children).filter(el => el instanceof HTMLElement).map(el => [el, el.inert]);
    const clean = () => {
      if (closed) return;
      closed = true;
      clearTimeout(watchdog);
      clearTimeout(startupDeadline);
      animations.forEach(animation => animation.cancel());
      resizeObserver?.disconnect();
      overlay.remove();
      document.body.style.overflow = previous.overflow;
      document.body.style.paddingRight = previous.padding;
      inert.forEach(([element, wasInert]) => { element.inert = wasInert; });
      window.removeEventListener('keydown', skip);
      window.removeEventListener('resize', clean);
      window.removeEventListener('pagehide', clean);
      document.removeEventListener('shopify:section:unload', clean);
      if (focused instanceof HTMLElement && focused !== document.body && focused.isConnected) focused.focus({ preventScroll: true });
    };
    const skip = event => { if (event.key === 'Escape') clean(); };
    const watchdog = setTimeout(clean, 10500);
    startupDeadline = setTimeout(clean, 3000);
    try {
      const gutter = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = (parseFloat(getComputedStyle(document.body).paddingRight) + gutter) + 'px';
      document.body.style.overflow = 'hidden';
      window.scrollTo({ top: 0, behavior: 'instant' });
      inert.forEach(([element]) => { element.inert = true; });
      document.body.append(overlay);
      window.addEventListener('keydown', skip);
      window.addEventListener('pagehide', clean);
      document.addEventListener('shopify:section:unload', clean);
      if (!measure()) return clean();
      part('calendar-backdrop').style.backgroundImage = `url(${JSON.stringify(config.table)})`;
      const decode = src => {
        const image = new Image();
        image.fetchPriority = 'high';
        image.src = src;
        return image.decode();
      };
      const hero = target.closest('.tutorial-video-hero');
      const fonts = document.fonts && hero
        ? Array.from(hero.querySelectorAll('h1, h2, p, .tutorial-video-hero__subtitle')).map(element => {
          const style = getComputedStyle(element);
          return document.fonts.load(`${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`, element.textContent);
        })
        : [];
      Promise.all([...fonts, ...[config.table, config.cover].filter(Boolean).map(decode)])
        .then(() => {
          if (closed) return;
          clearTimeout(startupDeadline);
          const geometry = measure();
          if (!geometry) return clean();
          animate(geometry);
          window.addEventListener('resize', clean);
          resizeObserver = new ResizeObserver(() => {
            const next = target.getBoundingClientRect();
            if (Math.abs(next.width - geometry.targetWidth) > 2 || Math.abs(next.height - geometry.targetHeight) > 2) clean();
          });
          resizeObserver.observe(target);
        }).catch(clean);
    } catch { clean(); }

    function measure() {
      const rect = target.getBoundingClientRect();
      if (!rect.width || !rect.height) return null;
      const vw = window.innerWidth, vh = window.innerHeight;
      const w = target.offsetWidth, h = target.offsetHeight;
      const x = rect.left + rect.width / 2 - w / 2, y = rect.top + rect.height / 2 - h / 2;
      if (rect.top < 0 || rect.bottom > vh || rect.left < 0 || rect.right > vw) return null;
      const matrix = new DOMMatrixReadOnly(getComputedStyle(target).transform);
      const rotation = Math.atan2(matrix.b, matrix.a) * 180 / Math.PI;
      const crop = config.crop;
      const aspect = crop ? crop.w / crop.h : Number(config.aspect) || 1.4;
      const pw = Math.max(vw, vh * aspect), ph = pw / aspect;
      const px = (vw - pw) * (vw <= 760 ? .25 : .5), py = (vh - ph) / 2;
      const scale = Math.min(vw * .62 / pw, vh * .56 / ph);
      const tx = vw / 2 - scale * (px + pw / 2), ty = vh / 2 - scale * (py + ph / 2);
      const vars = {
        'door-x': x + 'px', 'door-y': y + 'px', 'door-w': w + 'px', 'door-h': h + 'px',
        'print-w': pw + 'px', 'print-h': ph + 'px', 'print-x': px + 'px', 'print-y': py + 'px',
        'camera-start': `translate(${tx}px, ${ty}px) scale(${scale})`,
        'door-perspective': Math.max(2200, w * 3.6) + 'px',
        'cover-image': config.cover ? `url(${JSON.stringify(config.cover)})` : 'none',
        'cover-size': crop ? `${pw * crop.imageW / crop.w}px ${ph * crop.imageH / crop.h}px` : '100% 100%',
        'cover-position': crop ? `${-pw * crop.x / crop.w}px ${-ph * crop.y / crop.h}px` : 'center',
      };
      Object.entries(vars).forEach(([key, value]) => overlay.style.setProperty('--' + key, value));
      part('calendar-hinge').style.transform = `rotate(${rotation}deg)`;
      part('aperture-rim').style.transform = `rotate(${rotation}deg)`;
      const print = part('flap-print');
      print.style.transformOrigin = `${w / 2 - px + x}px ${h / 2 - py + y}px`;
      print.style.transform = `rotate(${-rotation}deg)`;
      const rad = rotation * Math.PI / 180;
      const corner = (dx, dy) => `${x + w / 2 + dx * Math.cos(rad) - dy * Math.sin(rad) - px}px ${y + h / 2 + dx * Math.sin(rad) + dy * Math.cos(rad) - py}px`;
      const corners = [corner(-w / 2, -h / 2), corner(-w / 2, h / 2), corner(w / 2, h / 2), corner(w / 2, -h / 2), corner(-w / 2, -h / 2)];
      part('calendar-board').style.clipPath = `polygon(evenodd, 0px 0px, ${pw}px 0px, ${pw}px ${ph}px, 0px ${ph}px, 0px 0px, ${corners.join(', ')})`;
      return { x, y, w, h, vw, vh, scale, tx, ty, rotation, targetWidth: rect.width, targetHeight: rect.height };
    }

    function animate({ x, y, w, h, vw, vh, scale, tx, ty, rotation }) {
      const smooth = value => { const t = Math.max(0, Math.min(1, value)); return t * t * t * (t * (t * 6 - 15) + 10); };
      const tracks = Array.from({ length: 7 }, () => []);
      for (let step = 0; step <= 160; step++) {
        const offset = step / 160;
        const close = smooth((offset - .055) / .305);
        const cameraScale = Math.pow(scale, 1 - close), tableScale = cameraScale / scale;
        const opening = smooth((offset - .33) / .49), angle = opening * 148;
        tracks[0].push({ offset, transform: `translate(${tx * (1 - close)}px, ${ty * (1 - close)}px) scale(${cameraScale})` });
        tracks[1].push({ offset, transform: `translate(${tx * (1 - close - tableScale)}px, ${ty * (1 - close - tableScale)}px) scale(${tableScale})`, opacity: 1 - smooth((offset - .32) / .055) });
        tracks[2].push({ offset, opacity: 1 - smooth((offset - .82) / .18) });
        tracks[3].push({ offset, transform: `rotateY(${config.hinge === 'right' ? angle : -angle}deg)` });
        tracks[4].push({ offset, opacity: .65 * smooth(opening / .18) * (1 - smooth((opening - .55) / .45)), transform: `rotate(${rotation}deg) scaleX(${.2 + .8 * Math.sin(angle * Math.PI / 180)})` });
        tracks[5].push({ offset, opacity: .55 * Math.sin(Math.min(angle, 90) * Math.PI / 180) });
        tracks[6].push({ offset, opacity: .6 - .52 * smooth((angle - 80) / 68) });
      }
      const duration = Math.max(4000, Math.min(7000, Number(config.duration) || 6000));
      const names = ['calendar-camera', 'calendar-backdrop', 'calendar-sheet', 'calendar-flap', 'aperture-shadow', 'paper-light-front', 'paper-light-back'];
      names.forEach((name, index) => animations.push(part(name).animate(tracks[index], { duration, fill: 'both' })));
      const time = document.timeline.currentTime;
      animations.forEach(animation => { animation.startTime = time; });
      Promise.all(animations.map(animation => animation.finished)).then(clean, clean);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fr-shipping-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const DELAY_MS = 5000;

    const initializeNotice = () => {
      const dialog = document.getElementById('FrShippingNotice');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      const sessionKey = 'gruendl_fr_shipping_notice_v1';
      const cookieSeen = document.cookie.split(';').some((cookie) => cookie.trim() === `${sessionKey}=1`);
      let storageSeen = false;
      try {
        storageSeen = sessionStorage.getItem(sessionKey) === '1';
      } catch {}
      if (cookieSeen || storageSeen) return;

      dialog.querySelectorAll('[data-fr-shipping-dismiss]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });
      let pointerStartedOutside = false;
      const isOutside = (event) => {
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      };
      dialog.addEventListener('pointerdown', (event) => {
        pointerStartedOutside = event.target === dialog && isOutside(event);
      });
      dialog.addEventListener('click', (event) => {
        if (pointerStartedOutside && event.target === dialog && isOutside(event)) dialog.close();
        pointerStartedOutside = false;
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('fr-shipping-notice-open');
      });

      window.setTimeout(() => {
        if (dialog.open) return;
        dialog.showModal();
        document.documentElement.classList.add('fr-shipping-notice-open');
        document.cookie = `${sessionKey}=1; Path=/; SameSite=Lax; Secure`;
        try {
          sessionStorage.setItem(sessionKey, '1');
        } catch {}
      }, DELAY_MS);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeNotice, { once: true });
    } else {
      initializeNotice();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pattern-donation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('donation-amount-preview')) {
    customElements.define('donation-amount-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.custom = this.querySelector('.donation-preview__custom');
        this.customChoice = this.querySelector('.donation-preview__option--custom');
        this.input = this.custom.querySelector('input');
        this.error = this.custom.querySelector('[role="alert"]');
        this.cartError = this.querySelector('[data-cart-error]');
        this.output = this.querySelector('output');
        this.result = this.querySelector('[role="status"]');
        this.button = this.querySelector('button');
        if (document.querySelector('cart-drawer')) this.button.setAttribute('aria-haspopup', 'dialog');
        this.format = new Intl.NumberFormat(this.dataset.locale || 'de', { style: 'currency', currency: 'EUR' });
        this.form.addEventListener('change', (event) => {
          if (event.target.type !== 'radio') return;
          const custom = event.target.value === 'custom';
          this.custom.hidden = !custom;
          this.customChoice.classList.toggle('is-editing', custom);
          this.input.disabled = !custom;
          this.update(false);
          if (custom) this.input.focus();
        });
        this.input.addEventListener('input', () => this.update(false));
        this.input.addEventListener('blur', () => this.update(true));
        this.form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (this.busy) return;
          const cents = this.update(true);
          if (cents === null) { this.input.focus(); return; }
          const amount = cents / 100;
          const items = [{ id: this.dataset.patternId, quantity: 1 }];
          if (amount > 0) items.push({ id: this.dataset.donationId, quantity: amount });
          if (this.dataset.preview === 'true') {
            this.previewItems = items;
            this.result.querySelector('[data-result-amount]').textContent = this.format.format(amount);
            this.result.querySelector('[data-result-quantity]').textContent = String(amount);
            this.result.querySelector('[data-donation-line]').hidden = amount === 0;
            this.result.hidden = false;
            return;
          }
          this.busy = true;
          this.button.disabled = true;
          this.button.setAttribute('aria-busy', 'true');
          try {
            if (!this.dataset.patternId || this.dataset.patternPrice !== '0' || this.dataset.patternAvailable !== 'true' || this.dataset.currency !== 'EUR') throw new Error();
            const root = window.Shopify.routes.root;
            if (amount > 0) {
              const response = await fetch(root + 'products/' + this.dataset.donationHandle + '.js');
              if (!response.ok) throw new Error();
              const donation = await response.json();
              const variant = donation.variants.find((item) => String(item.id) === this.dataset.donationId);
              if (!variant || !variant.available || variant.price !== 100 || variant.requires_shipping) throw new Error();
            }
            const drawer = document.querySelector('cart-drawer');
            const payload = { items };
            if (drawer && typeof drawer.renderContents === 'function') {
              payload.sections = drawer.getSectionsToRender().map((section) => section.id);
              payload.sections_url = window.location.pathname;
              drawer.setActiveElement(this.button);
            }
            const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            if (!response.ok) throw new Error();
            const cartData = await response.json();
            if (payload.sections && payload.sections.every((id) => cartData.sections?.[id])) {
              try {
                drawer.classList.remove('is-empty');
                drawer.renderContents(cartData);
              } catch {
                window.location.assign(this.dataset.cartUrl);
              }
            } else {
              window.location.assign(this.dataset.cartUrl);
            }
          } catch {
            this.cartError.textContent = this.dataset.error;
            this.cartError.hidden = false;
          } finally {
            this.busy = false;
            this.button.disabled = false;
            this.button.removeAttribute('aria-busy');
          }
        });
        this.update(false);
      }
      update(showError) {
        const selected = this.form.querySelector('input[type="radio"]:checked').value;
        const value = selected === 'custom' ? this.input.value.trim() : selected;
        const valid = /^\d{1,6}$/.test(value);
        const cents = valid ? Number(value) * 100 : null;
        this.error.hidden = valid || !showError;
        this.input.setAttribute('aria-invalid', String(!valid && showError));
        this.output.textContent = valid ? this.format.format(cents / 100) : '—';
        this.result.hidden = true;
        this.cartError.hidden = true;
        this.button.disabled = !!this.busy;
        return cents;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
